export const movies={
    "page": 1,
    "results": [
    {
    "adult": false,
    "backdrop_path": "/7ucaMpXAmlIM24qZZ8uI9hCY0hm.jpg",
    "genre_ids": [
    14,
    12,
    28
    ],
    "id": 338953,
    "original_language": "en",
    "original_title": "Fantastic Beasts: The Secrets of Dumbledore",
    "overview": "Professor Albus Dumbledore knows the powerful, dark wizard Gellert Grindelwald is moving to seize control of the wizarding world. Unable to stop him alone, he entrusts magizoologist Newt Scamander to lead an intrepid team of wizards and witches. They soon encounter an array of old and new beasts as they clash with Grindelwald's growing legion of followers.",
    "popularity": 8020.641,
    "poster_path": "/jrgifaYeUtTnaH7NF5Drkgjg2MB.jpg",
    "release_date": "2022-04-06",
    "title": "Fantastic Beasts: The Secrets of Dumbledore",
    "video": false,
    "vote_average": 6.8,
    "vote_count": 1398
    },
    {
    "adult": false,
    "backdrop_path": "/gG9fTyDL03fiKnOpf2tr01sncnt.jpg",
    "genre_ids": [
    28,
    878,
    14
    ],
    "id": 526896,
    "original_language": "en",
    "original_title": "Morbius",
    "overview": "Dangerously ill with a rare blood disorder, and determined to save others suffering his same fate, Dr. Michael Morbius attempts a desperate gamble. What at first appears to be a radical success soon reveals itself to be a remedy potentially worse than the disease.",
    "popularity": 4123.569,
    "poster_path": "/6JjfSchsU6daXk2AKX8EEBjO3Fm.jpg",
    "release_date": "2022-03-30",
    "title": "Morbius",
    "video": false,
    "vote_average": 6.4,
    "vote_count": 1415
    },
    {
    "adult": false,
    "backdrop_path": "/egoyMDLqCxzjnSrWOz50uLlJWmD.jpg",
    "genre_ids": [
    28,
    12,
    10751,
    35
    ],
    "id": 675353,
    "original_language": "en",
    "original_title": "Sonic the Hedgehog 2",
    "overview": "After settling in Green Hills, Sonic is eager to prove he has what it takes to be a true hero. His test comes when Dr. Robotnik returns, this time with a new partner, Knuckles, in search for an emerald that has the power to destroy civilizations. Sonic teams up with his own sidekick, Tails, and together they embark on a globe-trotting journey to find the emerald before it falls into the wrong hands.",
    "popularity": 3990.395,
    "poster_path": "/6DrHO1jr3qVrViUO6s6kFiAGM7.jpg",
    "release_date": "2022-03-30",
    "title": "Sonic the Hedgehog 2",
    "video": false,
    "vote_average": 7.7,
    "vote_count": 1842
    },
    {
    "adult": false,
    "backdrop_path": "/1Ds7xy7ILo8u2WWxdnkJth1jQVT.jpg",
    "genre_ids": [
    28,
    12,
    35
    ],
    "id": 752623,
    "original_language": "en",
    "original_title": "The Lost City",
    "overview": "A reclusive romance novelist was sure nothing could be worse than getting stuck on a book tour with her cover model until a kidnapping attempt sweeps them both into a cutthroat jungle adventure, proving life can be so much stranger, and more romantic, than any of her paperback fictions.",
    "popularity": 3888.712,
    "poster_path": "/neMZH82Stu91d3iqvLdNQfqPPyl.jpg",
    "release_date": "2022-03-24",
    "title": "The Lost City",
    "video": false,
    "vote_average": 6.8,
    "vote_count": 955
    },
    {
    "adult": false,
    "backdrop_path": "/kiH3KPWi7BaRMvdAigcwrUFViHl.jpg",
    "genre_ids": [
    28,
    53,
    80
    ],
    "id": 818397,
    "original_language": "en",
    "original_title": "Memory",
    "overview": "Alex, an assassin-for-hire, finds that he's become a target after he refuses to complete a job for a dangerous criminal organization. With the crime syndicate and FBI in hot pursuit, Alex has the skills to stay ahead, except for one thing: he is struggling with severe memory loss, affecting his every move. Alex must question his every action and whom he can ultimately trust.",
    "popularity": 3503.147,
    "poster_path": "/QaNLpq3Wuu2yp5ESsXYcQCOpUk.jpg",
    "release_date": "2022-04-28",
    "title": "Memory",
    "video": false,
    "vote_average": 7.3,
    "vote_count": 200
    },
    {
    "adult": false,
    "backdrop_path": "/cqnVuxXe6vA7wfNWubak3x36DKJ.jpg",
    "genre_ids": [
    28,
    12,
    14
    ],
    "id": 639933,
    "original_language": "en",
    "original_title": "The Northman",
    "overview": "Prince Amleth is on the verge of becoming a man when his father is brutally murdered by his uncle, who kidnaps the boy's mother. Two decades later, Amleth is now a Viking who's on a mission to save his mother, kill his uncle and avenge his father.",
    "popularity": 2844.354,
    "poster_path": "/zhLKlUaF1SEpO58ppHIAyENkwgw.jpg",
    "release_date": "2022-04-07",
    "title": "The Northman",
    "video": false,
    "vote_average": 7.3,
    "vote_count": 1324
    },
    {
    "adult": false,
    "backdrop_path": "/6tZeX0gvlPzHU8phHuiZD8Gsa11.jpg",
    "genre_ids": [
    14,
    28,
    12
    ],
    "id": 453395,
    "original_language": "en",
    "original_title": "Doctor Strange in the Multiverse of Madness",
    "overview": "Doctor Strange, with the help of mystical allies both old and new, traverses the mind-bending and dangerous alternate realities of the Multiverse to confront a mysterious new adversary.",
    "popularity": 2474.966,
    "poster_path": "/9Gtg2DzBhmYamXBS1hKAhiwbBKS.jpg",
    "release_date": "2022-05-04",
    "title": "Doctor Strange in the Multiverse of Madness",
    "video": false,
    "vote_average": 7.4,
    "vote_count": 2092
    },
    {
    "adult": false,
    "backdrop_path": "/aEGiJJP91HsKVTEPy1HhmN0wRLm.jpg",
    "genre_ids": [
    28,
    12
    ],
    "id": 335787,
    "original_language": "en",
    "original_title": "Uncharted",
    "overview": "A young street-smart, Nathan Drake and his wisecracking partner Victor “Sully” Sullivan embark on a dangerous pursuit of “the greatest treasure never found” while also tracking clues that may lead to Nathan’s long-lost brother.",
    "popularity": 2419.112,
    "poster_path": "/tlZpSxYuBRoVJBOpUrPdQe9FmFq.jpg",
    "release_date": "2022-02-10",
    "title": "Uncharted",
    "video": false,
    "vote_average": 7.2,
    "vote_count": 2260
    },
    {
    "adult": false,
    "backdrop_path": "/flTnaBaW1UnQtzGEIoHR7C3OYfy.jpg",
    "genre_ids": [
    878,
    28,
    12,
    53
    ],
    "id": 507086,
    "original_language": "en",
    "original_title": "Jurassic World Dominion",
    "overview": "Four years after Isla Nublar was destroyed, dinosaurs now live—and hunt—alongside humans all over the world. This fragile balance will reshape the future and determine, once and for all, whether human beings are to remain the apex predators on a planet they now share with history’s most fearsome creatures.",
    "popularity": 2360.914,
    "poster_path": "/98kYjbpa4MNAeW6qw8Kb1o2ylLj.jpg",
    "release_date": "2022-06-01",
    "title": "Jurassic World Dominion",
    "video": false,
    "vote_average": 6.9,
    "vote_count": 71
    },
    {
    "adult": false,
    "backdrop_path": "/iQFcwSGbZXMkeyKrxbPnwnRo5fl.jpg",
    "genre_ids": [
    28,
    12,
    878
    ],
    "id": 634649,
    "original_language": "en",
    "original_title": "Spider-Man: No Way Home",
    "overview": "Peter Parker is unmasked and no longer able to separate his normal life from the high-stakes of being a super-hero. When he asks for help from Doctor Strange the stakes become even more dangerous, forcing him to discover what it truly means to be Spider-Man.",
    "popularity": 2261.524,
    "poster_path": "/1g0dhYtq4irTY1GPXvft6k4YLjm.jpg",
    "release_date": "2021-12-15",
    "title": "Spider-Man: No Way Home",
    "video": false,
    "vote_average": 8.1,
    "vote_count": 13250
    },
    {
    "adult": false,
    "backdrop_path": "/xHrp2pq73oi9D64xigPjWW1wcz1.jpg",
    "genre_ids": [
    80,
    9648,
    53
    ],
    "id": 414906,
    "original_language": "en",
    "original_title": "The Batman",
    "overview": "In his second year of fighting crime, Batman uncovers corruption in Gotham City that connects to his own family while facing a serial killer known as the Riddler.",
    "popularity": 2230.268,
    "poster_path": "/74xTEgt7R36Fpooo50r9T25onhq.jpg",
    "release_date": "2022-03-01",
    "title": "The Batman",
    "video": false,
    "vote_average": 7.8,
    "vote_count": 4964
    },
    {
    "adult": false,
    "backdrop_path": "/fOy2Jurz9k6RnJnMUMRDAgBwru2.jpg",
    "genre_ids": [
    16,
    10751,
    35,
    14
    ],
    "id": 508947,
    "original_language": "en",
    "original_title": "Turning Red",
    "overview": "Thirteen-year-old Mei is experiencing the awkwardness of being a teenager with a twist – when she gets too excited, she transforms into a giant red panda.",
    "popularity": 1790.973,
    "poster_path": "/qsdjk9oAKSQMWs0Vt5Pyfh6O4GZ.jpg",
    "release_date": "2022-03-10",
    "title": "Turning Red",
    "video": false,
    "vote_average": 7.5,
    "vote_count": 2343
    },
    {
    "adult": false,
    "backdrop_path": "/hcNM0HjfPonIzOVy6LVTDBXSfMq.jpg",
    "genre_ids": [
    28,
    53,
    80
    ],
    "id": 864116,
    "original_language": "en",
    "original_title": "A Day to Die",
    "overview": "A disgraced parole officer is indebted to a local gang leader and forced to pull off a series of dangerous drug heists within twelve hours in order to pay the $2 million dollars he owes, rescue his kidnapped pregnant wife, and settle a score with the city's corrupt police chief, who is working with the gang leader and double-crossed him years ago.",
    "popularity": 1725.439,
    "poster_path": "/8Kce1utfytAG5m1PbtVoDzmDZJH.jpg",
    "release_date": "2022-03-04",
    "title": "A Day to Die",
    "video": false,
    "vote_average": 5.9,
    "vote_count": 42
    },
    {
    "adult": false,
    "backdrop_path": "/figlwUsXXFehX3IebdjqNLV6vWk.jpg",
    "genre_ids": [
    28,
    53
    ],
    "id": 628900,
    "original_language": "en",
    "original_title": "The Contractor",
    "overview": "After being involuntarily discharged from the U.S. Special Forces, James Harper decides to support his family by joining a private contracting organization alongside his best friend and under the command of a fellow veteran. Overseas on a covert mission, Harper must evade those trying to kill him while making his way back home.",
    "popularity": 1573.025,
    "poster_path": "/rJPGPZ5soaG27MK90oKpioSiJE2.jpg",
    "release_date": "2022-03-10",
    "title": "The Contractor",
    "video": false,
    "vote_average": 6.6,
    "vote_count": 278
    },
    {
    "adult": false,
    "backdrop_path": "/fEe5fe82qHzjO4yej0o79etqsWV.jpg",
    "genre_ids": [
    16,
    35,
    10751,
    80
    ],
    "id": 629542,
    "original_language": "en",
    "original_title": "The Bad Guys",
    "overview": "When the infamous Bad Guys are finally caught after years of countless heists and being the world’s most-wanted villains, Mr. Wolf brokers a deal to save them all from prison.",
    "popularity": 1515.453,
    "poster_path": "/7qop80YfuO0BwJa1uXk1DXUUEwv.jpg",
    "release_date": "2022-03-17",
    "title": "The Bad Guys",
    "video": false,
    "vote_average": 7.8,
    "vote_count": 558
    },
    {
    "adult": false,
    "backdrop_path": "/qK7Ssnrfvrt65F66A1thvehfQg2.jpg",
    "genre_ids": [
    16,
    10751,
    35,
    12,
    9648
    ],
    "id": 420821,
    "original_language": "en",
    "original_title": "Chip 'n Dale: Rescue Rangers",
    "overview": "Decades after their successful television series was canceled, Chip and Dale must repair their broken friendship and take on their Rescue Rangers detective personas once again when a former cast mate mysteriously disappears.",
    "popularity": 1508.121,
    "poster_path": "/7UGmn8TyWPPzkjhLUW58cOUHjPS.jpg",
    "release_date": "2022-05-18",
    "title": "Chip 'n Dale: Rescue Rangers",
    "video": false,
    "vote_average": 7.2,
    "vote_count": 412
    },
    {
    "adult": false,
    "backdrop_path": "/jCDycDqFJ1dIv5iJfTfub2h4ZAB.jpg",
    "genre_ids": [
    27
    ],
    "id": 836225,
    "original_language": "en",
    "original_title": "The Exorcism of God",
    "overview": "An American priest working in Mexico is considered a saint by many local parishioners. However, due to a botched exorcism, he carries a secret that’s eating him alive until he gets an opportunity to face his demon one final time.",
    "popularity": 1395.097,
    "poster_path": "/hangTmbxpSV4gpHG7MgSlCWSSFa.jpg",
    "release_date": "2022-02-10",
    "title": "The Exorcism of God",
    "video": false,
    "vote_average": 6.8,
    "vote_count": 202
    },
    {
    "adult": false,
    "backdrop_path": "/dW3fQJrshh2wYDoW4HUA7ZabsN1.jpg",
    "genre_ids": [
    28,
    53,
    80
    ],
    "id": 763285,
    "original_language": "en",
    "original_title": "Ambulance",
    "overview": "Decorated veteran Will Sharp, desperate for money to cover his wife's medical bills, asks for help from his adoptive brother Danny. A charismatic career criminal, Danny instead offers him a score: the biggest bank heist in Los Angeles history: $32 million.",
    "popularity": 1206.814,
    "poster_path": "/zT5ynZ0UR6HFfWQSRf2uKtqCyWD.jpg",
    "release_date": "2022-03-16",
    "title": "Ambulance",
    "video": false,
    "vote_average": 7,
    "vote_count": 718
    },
    {
    "adult": false,
    "backdrop_path": "/9Ngw106BLlNJ4iVpRHlrDfaLpCV.jpg",
    "genre_ids": [
    878,
    12,
    28
    ],
    "id": 406759,
    "original_language": "en",
    "original_title": "Moonfall",
    "overview": "A mysterious force knocks the moon from its orbit around Earth and sends it hurtling on a collision course with life as we know it.",
    "popularity": 1204.865,
    "poster_path": "/odVv1sqVs0KxBXiA8bhIBlPgalx.jpg",
    "release_date": "2022-02-03",
    "title": "Moonfall",
    "video": false,
    "vote_average": 6.5,
    "vote_count": 1161
    },
    {
    "adult": false,
    "backdrop_path": "/wtbRUVxQVvU6QIJH1oGLDThJLib.jpg",
    "genre_ids": [
    35,
    28
    ],
    "id": 785985,
    "original_language": "fr",
    "original_title": "Loin du périph",
    "overview": "Ousmane Diakité and François Monge are two cops with very different styles, backgrounds and careers. The unlikely pair are reunited once again for a new investigation that takes them across France. What seemed to be a simple drug deal turns out to be a much bigger criminal case wrapped in danger and unexpected comedy.",
    "popularity": 1173.717,
    "poster_path": "/h5hVeCfYSb8gIO0F41gqidtb0AI.jpg",
    "release_date": "2022-05-06",
    "title": "The Takedown",
    "video": false,
    "vote_average": 5.9,
    "vote_count": 199
    }
    ],
    "total_pages": 33804,
    "total_results": 676066
    }